import { BrandsApi } from 'api/Brands'
import Brands from 'elements/Brands/Brands'
import useFetch from 'elements/Hooks/useFetch'
import useModalData from 'elements/Hooks/useModalData'
import React from 'react'

function BrandsCont({ owner }) {
  const { data: list, fetching, fetch } = useFetch({
    url: `/brands/owner/${owner}`,
  })

  const crud = useModalData(BrandsApi.create, BrandsApi.update, BrandsApi.remove, fetch)

  async function submit() {
    const submitted = await crud.submit({ owner })
    if (submitted) fetch()
  }

  return (
    <Brands
      {...{
        ...crud,
        submit,
        list,
        fetching,
        fetch,
      }}
    />
  )
}

export default BrandsCont
